import { requests } from '../../api/services';
import {
    LIST_OFFER_PDF_URL,
    OFFER_PDF_CAMPAIGNS_AUTOCOMPLETE_URL,
    OFFER_PDF_INFLUENCERS_AUTOCOMPLETE_URL,
    OFFER_PDF_OFFERS_AUTOCOMPLETE_URL,
    OFFER_PDF_SENT_BY_AUTOCOMPLETE_URL,
} from '../../utils/Endpoints';
import { BaseModel } from '../../model/shared/BaseModel';
import {
    OfferPdf,
    OfferPdfCampaignAutocomplete,
    OfferPdfOfferAutocomplete,
    OfferPdfUserAutocomplete,
} from '../../model/offer/OfferPdf';

export const OfferPdfService = {
    getOfferPdfs: (params: any): Promise<BaseModel<OfferPdf>> => requests.get(`${LIST_OFFER_PDF_URL}`, params),
    getOffersAutocomplete: (search: string): Promise<OfferPdfOfferAutocomplete[]> =>
        requests.get(`${OFFER_PDF_OFFERS_AUTOCOMPLETE_URL}`, { search }),
    getCampaignsAutocomplete: (search: string): Promise<OfferPdfCampaignAutocomplete[]> =>
        requests.get(`${OFFER_PDF_CAMPAIGNS_AUTOCOMPLETE_URL}`, { search }),
    getInfluencersAutocomplete: (search: string): Promise<OfferPdfUserAutocomplete[]> =>
        requests.get(`${OFFER_PDF_INFLUENCERS_AUTOCOMPLETE_URL}`, { search }),
    getSentByAutocomplete: (search: string): Promise<OfferPdfUserAutocomplete[]> =>
        requests.get(`${OFFER_PDF_SENT_BY_AUTOCOMPLETE_URL}`, { search }),
    regeneratePdf: (id: number): Promise<OfferPdf> => requests.put(`${LIST_OFFER_PDF_URL}/${id}/regenerate`, {}),
};
